import { inAppChatService } from '@egw/app-chat'
import { Button, ButtonVariant, Link, LinkVariant, PageHeader } from '@egw/components'
import { configClient } from '@egw/config'
import { CUSTOMER_SERVICE_PHONE_NUMBER } from '@egw/constants'
import { Trans, useTranslation } from '@egw/i18n'
import { InformationCircleIcon, LockClosedIcon, ScaleIcon } from '@heroicons/react/20/solid'
import { type FC } from 'react'
import { type Config } from '../../types'

export const HelpCenter: FC = () => {
  const { t } = useTranslation('features-help-center')
  const config = configClient.getConfig() as Config

  return (
    <>
      <PageHeader title={t('help_center.title')} />
      <div className="egw-container">
        {/* Help Center Block */}
        <div className="flex flex-col gap-2xl">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col">
              <h2 className="typo-primary-xl-light text-text-header mb-sm">{t('help_center.speak_with_advisor')}</h2>
              <p className="typo-primary-base-regular text-text-body">
                <Trans t={t} i18nKey="help_center.speak_with_advisor_description">
                  <a
                    className="typo-primary-base-semibold text-text-action hover:underline cursor-pointer"
                    href="mailto:advisory@evergreenwealth.com"
                  />
                </Trans>
              </p>
            </div>
          </div>
          {/* Client Service Block */}
          <div>
            <div className="flex flex-row justify-between items-center">
              <h2 className="typo-primary-xl-light text-text-header mb-sm">{t('help_center.help_center_title')}</h2>
            </div>
            <div className="flex flex-col md:flex-row gap-4 w-full">
              <Link
                href={config.zendeskArticles.helpCenterLegal}
                variant={LinkVariant.secondary}
                className="flex-grow !py-xs !px-sm"
              >
                <span className="flex flex-row gap-4 md:gap-2 text-left md:text-center justify-start md:justify-center w-full typo-primary-base-semibold items-center">
                  <ScaleIcon className="w-5 h-5" />
                  {t('help_center.legal')}
                </span>
              </Link>
              <Link
                href={config.zendeskArticles.helpCenterPrivacy}
                variant={LinkVariant.secondary}
                className="flex-grow !py-xs !px-sm"
              >
                <span className="flex flex-row gap-4 md:gap-2 text-left md:text-center justify-start md:justify-center w-full typo-primary-base-semibold items-center">
                  <LockClosedIcon className="w-5 h-5" />
                  {t('help_center.privacy')}
                </span>
              </Link>

              <Link
                href={config.zendeskArticles.helpCenterFAQs}
                variant={LinkVariant.secondary}
                className="flex-grow !py-xs !px-sm"
              >
                <span className="flex flex-row gap-4 md:gap-2 text-left md:text-center justify-start md:justify-center w-full typo-primary-base-semibold items-center">
                  <InformationCircleIcon className="w-5 h-5" />
                  {t('help_center.faqs')}
                </span>
              </Link>
            </div>
          </div>
          <div className="flex flex-col">
            <h2 className="typo-primary-xl-light text-text-header mb-sm">{t('help_center.talk_to_client_service')}</h2>
            <p className="typo-primary-base-regular text-text-body">
              <Trans t={t} i18nKey="help_center.talk_to_client_service_description">
                <a
                  content=""
                  className="typo-primary-base-semibold text-text-action hover:underline cursor-pointer"
                  href={`tel:${CUSTOMER_SERVICE_PHONE_NUMBER}`}
                />
                <a
                  content=""
                  className="typo-primary-base-semibold text-text-action hover:underline cursor-pointer"
                  href="mailto:clientservice@evergreenwealth.com"
                />
              </Trans>
            </p>
            <div className="flex flex-row gap-sm mt-md">
              <Button
                variant="secondary"
                testId="chat-cta"
                className="md:w-fit"
                onClick={() => {
                  inAppChatService.open()
                }}
              >
                {t('help_center.chat_cta')}
              </Button>
              <Button
                variant={ButtonVariant.Secondary}
                testId="call-us"
                className="md:w-fit"
                onClick={() => {
                  window.open(t('help_center.telephone_number'))
                }}
              >
                {t('help_center.call_us_cta')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
